import styled, { css } from "styled-components";

const BannerV1Wrapper = styled.section`
  min-height: 100vh;
  width: 100%;
  padding-top: 192px;

  ${({ item }) =>
    item &&
    css`
     background: url(${item});
     background-size: cover;
     background-position: top center;
     background-repeat: no-repeat;
  `}

  .banner_main{
    display: flex;
    justify-content: end;
    align-items: center;
    height: 100%;
  }
  .baner_left {
    width: 100%;
    margin-top: 90px;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    margin-left:auto;

    p {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 36px;
      text-transform: uppercase;
      color: #ffffff;
    }

    h2 {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 40px;
      // line-height: 80px;
      text-transform: uppercase;
      color: #ffffff;
      margin-bottom: 32px;
    }

    h3 {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 40px;
      line-height: 60px;
      text-transform: uppercase;
      color: #ffffff;
    }

    .banner_buttons {
      display: flex;
      column-gap: 30px;
      margin-top: 40px;
    }

    .coin-info {
      display: flex;
      flex-direction: column;
      margin-top: 37px;
      span {
        font-family: "Poppins";
        font-size: 18px;
        line-height: 36px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.8);

        & .highlighted {
          color: #ffe600;
        }
      }
    }
  }

  
  @media only screen and (max-width: 1199px) {
    padding-top: 130px;

    .baner_left {
      margin-top: 0;
      h2 {
        font-size: 50px;
        line-height: 65px;
      }

      h3 {
        font-size: 34px;
        line-height: 38px;
      }

      .baner_buttons {
        margin-top: 40px;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    .baner_left {
      margin-top: 0px;
      justify-content: flex-start;
    }
  }

  @media only screen and (max-width: 767px) {
    .baner_left {
      h2 {
        font-size: 40px;
        line-height: 50px;
        margin-bottom: 20px;
      }

      h3 {
        font-size: 28px;
        line-height: 38px;
        
      }

      .banner_buttons{
        margin-top: 25px;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .baner_left {
      h2 {
        font-size: 37px;
      }

      h3 {
        font-size: 22px;
      }

      .coin-info {
        font-size: 14px;
        line-height: 29px;
      }

      .banner_buttons{
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        padding-bottom: 20px;
      }

    }
  }

  @media (max-width: 375px) {
    .baner_left {
      h2 {
        font-size: 30px;
        line-height: 40px;
      }
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
      }
    }
  }

  @media (max-width: 360px) {
    .baner_left {
      .coin-info {
        font-size: 13px;
      }
    }
  }
`;

export default BannerV1Wrapper;
